module.exports = __webpack_public_path__ + "img/17.c391450f.png";